import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";

/**
 * "Muốn PDF thì in rồi chọn Save as PDF."
 *
 * Hệ thống KHÔNG nhúng thư viện PDF, và đó là quyết định có chủ ý: mọi bản in
 * đã là HTML dựng đúng mẫu, trình duyệt xuất ra tệp giống hệt bản in thật, còn
 * một thư viện PDF thì cộng 400 KB–2 MB vào mỗi lần tải trang của mọi người —
 * kể cả người không bao giờ in.
 *
 * Nhưng suốt thời gian qua chỉ hoá đơn chiếu lệ có câu nói ra điều đó, nên ở
 * mọi chứng từ khác người dùng tin là hệ thống không xuất được PDF. Khoảng
 * cách giữa "không có" và "có mà không ai biết" chỉ là một dòng chữ này.
 */
export function SaveAsPdfHint() {
  const { t } = useTranslation();
  return (
    <p className="flex items-center gap-1.5 text-xs text-ink-soft">
      <FileText className="size-3.5 shrink-0" aria-hidden="true" />
      {t("dataExport.pdfHint")}
    </p>
  );
}
